import { all, call, put, take } from 'redux-saga/effects';
import { LOAD_FEATURE_LIST } from '../type';
import {
  loadFeatureListSuccessAction,
  loadFeatureListErrorAction,
} from '../action';

import { roleService } from 'services';

function* loadFeatureList() {
  while (1) {
    const action = yield take(LOAD_FEATURE_LIST);
    try {
      const featureList = yield call(
        roleService.loadFeatureList,
        action.payload,
      );
      yield put(loadFeatureListSuccessAction(featureList));
    } catch (err) {
      yield put(loadFeatureListErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([loadFeatureList()]);
}
